import { STORE_NAME } from '@intigral/constant';
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { IMpxService } from '@intigral/domain/lib/application/services/MpxService';
import { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import { Skeleton } from '@intigral/shared';
import { Carousel2 } from '@intigral/ui';
import { get } from '@intigral/utils/lib/browser-storage/localStorage';
import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { getCountry } from '../helpers/common';

type ScreenCarouselProps = {
    carousel: Carousel;
};

export const RenderedComponent = ({ dataLoader, render, carousel, carouselIndex = null }) => {
    const location = useLocation();
    const selectedProfile = get(STORE_NAME.SELECTED_PROFILE);
    const { isLoading, isError, data, error } = useQuery<any>({
        queryKey: [
            'cms-load',
            carousel.id,
            carousel.title_resource_key,
            selectedProfile?.profileGuid ?? 'no-profile',
            location.search,
        ],
        queryFn: async () => {
            return await dataLoader(carousel);
        },
    });

    // Skeleton for carousel disabled to test whether it helps to avoid layout shifts
    // TODO: Revisit this later
    // if (isLoading) {
    //     return <Skeleton variant="rectangular" width="100%" height={'550px'} />;
    // }

    if (isError) {
        return null;
    }

    return render(carousel, data, carouselIndex, isLoading);
};

const ScreenCarousel = ({ carousel }: ScreenCarouselProps) => {
    const { isLoading, isError, data, error } = useQuery<any>({
        queryKey: ['cms-load', carousel.id, carousel.title_resource_key],
        queryFn: async () => {
            const carouselId = carousel.id;
            const carouselDataSource = carousel.dataSources?.[0] ?? '';

            if (carouselDataSource.startsWith('${mpx_base}')) {
                const carouselDataSource = carousel.dataSources?.[0] ?? '';
                const url = carouselDataSource.replace('${mpx_base}', 'https://feed.entertainment.tv.theplatform.eu/f');
                const mpxService = container.resolve<IMpxService>(DI.SERVICES.IMpxService);
                const result = await mpxService.getFeed(url, {
                    byCustomValue: `{PC}{${getCountry()}}`,
                });

                return result;
            }

            return {};
        },
    });

    const language = 'en';

    if (isLoading) {
        return 'loading component...';
    }

    if (isError) {
        return null;
    }

    return (
        <div>
            <h1>{carousel.title_resource_key}</h1>
            <Carousel2
                swiperSettings={{
                    autoplay: false,
                    loop: false,
                    dir: 'ltr',
                }}
                dir="ltr"
            >
                {data.entries
                    ?.map((d) => d.media && d.media[0].defaultThumbnailUrl)
                    .map((link) => (
                        <img src={link} alt="" style={{ width: '300px', objectFit: 'contain', marginInline: '5px' }} />
                    ))}
            </Carousel2>
        </div>
    );
};

export default ScreenCarousel;
